import {
  FetchAllProvider,
  FetchAuditProvider,
  FetchAllComparys,
  FetchAuditComparys,
  FetchUrgentComparys
} from "@/api/auditManage/auditMixin"; // 获取当前状态

import { findAllUrgentVehicles } from "@/api/auditManage/chillCarMessage.js";
import { findAllUrgentStorages } from "@/api/auditManage/storageMessage.js";

export default {
  data() {
    return {
      allProviderList: [], // 所有服务商信息
      auditProviderList: [], // 审核通过服务商
      allComparysList: [], // 所有企业信息
      auditComparysList: [], // 审核通过企业信息
      storageList: [], // 仓库下拉
      vehicleList: [], // 车辆下拉
      urgentComparysList: [] //企业下拉
    };
  },
  methods: {
    // 获取所有服务商
    async getAllProvider() {
      try {
        let res = await FetchAllProvider();
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result)) {
            this.allProviderList = res.result;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 获取审核通过服务商
    async getAuditProvider() {
      try {
        let res = await FetchAuditProvider();
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result)) {
            this.auditProviderList = res.result;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 获取所有企业信息
    async getAllComparys() {
      try {
        let res = await FetchAllComparys();
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result)) {
            this.allComparysList = res.result;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 获取审核通过企业信息
    async getAuditComparys() {
      try {
        let res = await FetchAuditComparys();
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result)) {
            this.auditComparysList = res.result;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 获取所有企业信息
    async getUrgentComparys() {
      try {
        let res = await FetchUrgentComparys();
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result)) {
            this.urgentComparysList = res.result;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    //获取仓库名称全量
    fecthAllUrgentStorageName() {
      findAllUrgentStorages()
        .then(res => {
          let list = [];
          if (res.code === 1 && Array.isArray(res.result)) {
            list = res.result;
          }
          this.storageList = list;
        })
        .catch(err => {
          console.log(err);
        });
    },

    //获取车辆名称全量
    fecthAllUrgentvehicleName() {
      findAllUrgentVehicles()
        .then(res => {
          let list = [];
          if (res.code === 1 && Array.isArray(res.result)) {
            list = res.result;
          }
          this.vehicleList = list;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
